import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Gps } from './../../shared/gps';

@Component({
  selector: 'app-whereami',
  templateUrl: './whereami.component.html',
  styleUrls: ['./whereami.component.css']
})
export class WhereamiComponent extends BaseComponent implements OnInit {
  @ViewChild('map', { static: true }) mapElement: any = {};
  gps = new Gps();
  map: any = {};

  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
  }

  async getLocation() {
    let { ok, data }: any = await this.gps.getLocation();
    if (!ok) return this.error("Cannot get GPS location: ", data);  

    this.showPosition(data);

  }

  showPosition(coord: any) { 
    const mapProperties = {
      center: new google.maps.LatLng(coord),
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);

    new google.maps.Marker({
      position: coord,
      map: this.map,
      title: "My Location",
    });

  }

}
